import { MutationFn } from '@percent/education-hosted-form/hooks/useMutation/useMutation.types'
import { SendOtpProps, VerifyOtpProps, VerifyOtpResponse } from './otp.types'

export const sendOtpAction: MutationFn<SendOtpProps, void> = async (client, { validationInviteId, ...body }) => {
  await client.post(`v1/validation-invites/${validationInviteId}/otp/send`, body)
}

export const verifyOtpAction: MutationFn<VerifyOtpProps, VerifyOtpResponse> = async (
  client,
  { validationInviteId, ...body }
) => {
  const response = await client.post(`v1/validation-invites/${validationInviteId}/otp/verify`, body)

  return response.data
}
